import type { ReactElement } from 'react'
import Link from 'next/link'
import { useCartItemContext } from './context/useCartItemContext'

/**
 * Shows the report link for serialized products
 */
function CartItemReport (): ReactElement | null {
  const { cartLine } = useCartItemContext()

  if (cartLine.item?.__typename !== 'SerializedProduct' || cartLine.item.report?.url == null || cartLine.item.report?.provider == null) {
    return null
  }

  return (
    <>
      &nbsp;<span className='text-gray-300'>|</span>&nbsp;<Link href={cartLine.item.report.url} target='_blank'>{cartLine.item.report.provider} Report</Link>
    </>
  )
}

export {
  CartItemReport
}
